import { Classes } from "./externals";
import React from "react";
export class SelectMenu extends React.PureComponent {
    render() {
        const { options, value, onChange, itemRenderer, disabled } = this.props;
        const renderer = itemRenderer ? itemRenderer : (x) => x;
        const hasValueInOptions = options.some((option) => option == value);
        return (React.createElement("div", { className: Classes.SELECT },
            React.createElement("select", { disabled: disabled, value: hasValueInOptions ? value : 0, onChange: (event) => onChange(event.target.value), "data-testid": "select-menu" },
                !hasValueInOptions && (React.createElement("option", { key: -1, value: 0, disabled: true }, "- Choose one -")),
                options.map((option, i) => (React.createElement("option", { key: i, value: option }, renderer(option)))))));
    }
}
//# sourceMappingURL=SelectMenu.js.map